import * as React from 'react';
import { GithubSourceControlSubStepWidget } from '../create-app/github/GithubSourceControlSubStepWidget';
import { AppModel } from '@journeyapps-platform/lib-journey-core';
import { GitHubSourceMetadata, SourceType } from '@journeyapps-platform/types-source-service';
import { useSystem } from '../../../hooks/useSystem';
import { CommonMigrateToWidget } from './CommonMigrateToWidget';

export interface MigrateAppToGithubWidgetProps {
  app: AppModel;
  close: () => any;
  createIntegration: () => any;
}

export const MigrateAppToGithubWidget: React.FC<MigrateAppToGithubWidgetProps> = (props) => {
  const { app } = props;
  const system = useSystem();

  return (
    <CommonMigrateToWidget<GitHubSourceMetadata>
      {...props}
      provider={SourceType.GitHub}
      generateSource={() => {
        return {
          type: SourceType.GitHub,
          properties: {
            owner: '',
            repo: ''
          }
        };
      }}
      generateMigrateWidget={({ payload, setPayload }) => {
        return (
          <GithubSourceControlSubStepWidget
            createIntegration={() => {
              props.createIntegration();
            }}
            org={props.app.org}
            name={app.model.name}
            payload={payload}
            payloadChanged={(payload) => {
              setPayload(payload);
            }}
            system={system}
          />
        );
      }}
    />
  );
};
